import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

/**
 * FIR 5471 Schedule E service. Save only: action_code=av6zsu, process_name=Save_schd_E.
 */
@Injectable({
  providedIn: 'root'
})
export class Fir5471ScheduleEService {

  constructor(private http: HttpClient) {}

  saveScheduleE(
    baseUrl: string,
    payload: { jsonSettings: any[]; jsonObj: { addrows: any[]; editrows: any[]; removerows: any[] } },
    globalService: any,
    filterParams: any,
    rowData: any
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=av6zsu`;
    let params = _.merge({}, globalService?.globalParams || {}, filterParams || {});
    params = _.extend({ jsonSettings: JSON.stringify(payload.jsonSettings || []) }, params);
    params = _.extend({ jsonObj: JSON.stringify(payload.jsonObj || { addrows: [], editrows: [], removerows: [] }) }, params);
    params.combination_key = rowData?.COMBINATION_KEY;
    params.jcd_key = (globalService?.globalParams?.jcd_key === '' || globalService?.globalParams?.jcd_key == null) ? '250' : globalService.globalParams.jcd_key;
    params.process_name = 'Save_schd_E';
    const body = this.toUrlEncoded(params);
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    return this.http.post<any>(url, body, { headers, withCredentials: true });
  }

  // Parity alias for AngularJS scheduleF5471EServiceFactory.saveSchedule5471SchdE
  saveSchedule5471SchdE(
    baseUrl: string,
    payload: { jsonSettings: any[]; jsonObj: { addrows: any[]; editrows: any[]; removerows: any[] } },
    globalService: any,
    filterParams: any,
    rowData: any
  ): Observable<any> {
    return this.saveScheduleE(baseUrl, payload, globalService, filterParams, rowData);
  }

  private toUrlEncoded(params: Record<string, any>): string {
    const parts: string[] = [];
    Object.keys(params).forEach(key => {
      const v = params[key];
      if (v !== undefined && v !== null) {
        parts.push(encodeURIComponent(key) + '=' + encodeURIComponent(typeof v === 'object' ? JSON.stringify(v) : String(v)));
      }
    });
    return parts.join('&');
  }
}
